<template>
  <div class="w-100 " style="background:linear-gradient(to bottom, #eeeeee -13%,#666666 90%);">
    <div class="container banner" style="height:300px">
      <b-row class="foot-banner">
        <b-col class="col-md-3 corp pan" style="">
          <h4 class="font-size-16 m-t-0 " style="padding-bottom:10px">
            <a href="/desc">关于</a>
          </h4>
          <ul>
            <li>
              <a href="javascript:;">{{$t("common.corp")}}</a>
            </li>
            <li>
              <a href="javascript:;">{{$t("Product.lisens")}}</a>
            </li>
            <li>
              <a href="javascript:;">{{$t("common.video")}}</a>
            </li>
            
          </ul>
        </b-col>
        <b-col class="col-md-3 products pan" style="">
          <h4 class="font-size-16 m-t-0 " style="padding-bottom:10px">
            <a href="/product">产品</a>
          </h4>
          <ul>
            <li>
              <a href="/product">{{$t("Product.Drop1")}}</a>
            </li>
            <li>
              <a href="/product">{{$t("Product.Drop2")}}</a>
            </li>
            <li>
              <a href="/product">{{$t("Product.Drop3")}}</a>
            </li>
            <li>
              <a href="/product">{{$t("Product.Drop4")}}</a>
            </li>
          </ul>
        </b-col>
        
        <b-col class="col-md-3 news pan" style="">
          <h4 class="font-size-16 m-t-0 " style="padding-bottom:10px">
            <a href="/news">新闻</a>
          </h4>
          <ul>
            <li>
              <a href="javascript:;">{{$t("common.tech")}}</a>
            </li>
            <li>
              <a href="javascript:;">{{$t("common.news")}}</a>
            </li>
            <li>
              <a href="javascript:;">{{$t("Home.iconTech")}}</a>
            </li>
            
          </ul>
        </b-col>
        <b-col class="contactUs col-md-3">
          <h4>联系我们</h4>
          <ul class="info-list">
            <li >
              <span ><i class="iconfont icon-dizhi"></i> {{$t("Contact.address")}}</span>
            </li>
            <li>
              <span ><i class="iconfont icon-dianhua"></i> {{$t("Contact.phone")}}</span>
            </li>
            <li>
              <span ><i class="iconfont icon-fax"></i> {{$t("Contact.fax")}}</span>
            </li>
            <li>
              <span ><i class="iconfont icon-liuyan"></i> {{$t("Contact.email")}}</span>
              
            </li>
          </ul>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
export default {
  name: "footbanner",
  data() {
    return {};
  }
};
</script>


<style scoped>
  .news li{
    padding: 7px 0;
    font-size: 15px;
    letter-spacing: 1px;
  }
  .corp li{
    padding: 7px 0;
    font-size: 15px;
    letter-spacing: 1px;
  }
  .products li{
    padding: 7px 0;
    font-size: 15px;
    letter-spacing: 1px;
  }
  @media (min-width: 768px) {
    .contactUs{
      flex: 0  0 30%;
      max-width: 30%;
    }
    .pan{
      flex: 0  0 23.333%;
      max-width: 23.333%;
    }
  }
  @media (max-width: 768px) {
      .contactUs{
      flex: 0  0 65%;
      max-width: 65%;
    }
    .pan{
      flex: 0  0 50%;
      max-width: 50%;
    }
    .news{
      flex: 0  0 35% !important;
      max-width: 35% !important;
    }
    .banner{
      height: auto !important;
    }
  }
  .contactUs h4{
    padding-bottom: 10px;
    color: #222;
  }
  .contactUs .iconfont::before{
    padding-right: 15px !important;
    font-size: 20px;
  }
  .contactUs .info-list li{
    /* padding: 5px 0; */
    font-size: 14px !important;
    color: #000;
  }
  .foot-banner{
    padding: 30px 0;
    font-family: 微软雅黑, "Segoe UI","Lucida Grande",Helvetica,Arial,"Microsoft YaHei",FreeSans,Arimo,"Droid Sans","wenquanyi micro hei","Hiragino Sans GB","Hiragino Sans GB W3",Roboto,Arial,sans-serif
  }
  .foot-banner h4 a,.col-md-3 li a{
    color: #222 ;
    transition: all .4s ease-out;
  }
  .foot-banner h4 a:hover,.col-md-3 li a:hover{
     color: cadetblue
  }
  h4{
    font-weight: 600;
  }
</style>